/**************
 * 以下枚举为传输后端api时的定义，多数和后端定义对齐的
 * 一定要集中在这个地方写，切勿散落在业务代码里
 *************/
import moment from 'moment';

/* 模块顶层类型枚举 */
export const ACTIVITYRECEIPTTYPEENUM = {
  APPLY: {
    key: 'APPLY',
    name: '活动报名',
    browserQuery: '1', //浏览器query=1或无
  },
  MANAGE: {
    key: 'MANAGE',
    name: '活动管理',
    browserQuery: '2', //浏览器query=2
  },
};

/* `我的关注`后端枚举ID值 */
export const MYFOLLOWKEYNUM = -1;

/* 弹窗类型枚举【分组管理和收藏关注弹窗】 */
export const STARANDMANAGETYPEENUM = {
  MANAGETYPE: 'ManageType', //分组
  STARTYPE: 'StarType', //关注
};

/* 活动列表-筛选器-报名状态字段枚举 */
export const APPLYVALIDSTATUSENUM = {
  ALL: {
    key: 'ALL',
    showVal: -1, //前端组件自身交互用到的值
    postVal: null, //传递到后端的值
    name: '全部',
  },
  NOAPPLY: {
    key: 'NOAPPLY',
    showVal: 1,
    postVal: 1,
    name: '待我报名',
  },
  // 2022.03.31需求新增枚举
  WAITIMPROVED: {
    key: 'WAITIMPROVED',
    showVal: 3,
    postVal: 3,
    name: '待完善素材',
  },
  HASAPPLY: {
    key: 'HASAPPLY',
    showVal: 2,
    postVal: 2,
    name: '我已报名',
  },
};

/* 活动列表-筛选器-活动状态字段枚举【传后端：空：全部 ，0:下线（已结束/失效）,1:上线（未结束/有效)】 */
export const ONLINEFLAGENUM = {
  ALL: {
    key: 'ALL',
    showVal: -1,
    postVal: null,
    name: '全部',
  },
  RUNNING: {
    key: 'RUNNING',
    showVal: 1,
    postVal: 1,
    name: '未结束',
  },
};

/* 活动列表排序传参枚举值 */
export const ORDERBYENUM = {
  BEGIN_TIME_ASC: {
    key: 'BEGIN_TIME_ASC',
    des: '活动开始时间升序',
  },
  BEGIN_TIME_DESC: {
    key: 'BEGIN_TIME_DESC',
    des: '活动开始时间降序',
  },
  LAST_ASSIGN_TIME_ASC: {
    key: 'LAST_ASSIGN_TIME_ASC',
    des: '最新获得资源时间升序',
  },
  LAST_ASSIGN_TIME_DESC: {
    key: 'LAST_ASSIGN_TIME_DESC',
    des: '最新获得资源时间降序',
  },
};

/* 活动列表拓展字段枚举值 */
export const EXTFIELDSENUM = {
  COMPLETE_RATIO: {
    key: 'COMPLETE_RATIO',
    des: '完成进度',
  },
  USEABLE_AREA_COUNT: {
    key: 'USEABLE_AREA_COUNT',
    des: '待我报名收品池',
  },
  WAIT_CHECK_COUNT: {
    key: 'WAIT_CHECK_COUNT',
    des: '待我审核素材数',
  },
  UN_MATERIAL_COUNT: {
    key: 'UN_MATERIAL_COUNT',
    des: '待完善商品素材',
  },
};

/* 收品列表拓展字段枚举值 */
export const RECEIPTEXTFIELDSENUM = {
  USEABLE_BATCH_COUNT: {
    key: 'USEABLE_BATCH_COUNT',
    des: '待我报名场次数',
  },
  WAIT_CHECK_COUNT: {
    key: 'WAIT_CHECK_COUNT',
    des: '待审核数',
  },
  COMPLETE_RATIO: {
    key: 'COMPLETE_RATIO',
    des: '完成进度',
  },
  SOON_BEGIN_BATCH_TIME: {
    key: 'SOON_BEGIN_BATCH_TIME',
    des: '即将开始场次', //【yyyy-MM-dd HH:mm:ss】
  },
};

/* 营销常规活动活动列表-buttons枚举 */
export const ACTIVITYLISTENUM = {
  YX_ACTIVITY_LIST_VIEW: {
    key: 'YX_ACTIVITY_LIST_VIEW',
    des: '进入活动',
  },
  YX_ACTIVITY_LIST_COLLECT: {
    key: 'YX_ACTIVITY_LIST_COLLECT',
    des: '收藏活动',
  },
  YX_ACTIVITY_LIST_COPY: {
    key: 'YX_ACTIVITY_LIST_COPY',
    des: '复制活动',
  },
};

/* 营销常规活动收品池列表-buttons枚举 */
export const AREALISTENUM = {
  YX_AREA_LIST_VIEW: {
    key: 'YX_AREA_LIST_VIEW',
    des: '查看详情',
  },
};

/* 营销常规活动活动列表-button-复制活动-类型枚举 */
export const ORIGINCOPYLISTEMUN = {
  ACTIVITYSETTING: {
    key: 'ACTIVITYSETTING',
    name: '活动设置',
    default: 1,
  },
  AREASETTING: {
    key: 'AREASETTING',
    name: '收品池设置 (不含收品池管理员)',
    default: 0,
  },
  QUALIFICATIONSETTING: {
    key: 'QUALIFICATIONSETTING',
    name: '资质设置',
    default: 0,
  },
  BATCHSETTING: {
    key: 'BATCHSETTING',
    name: '场次设置 (过期场次不会被复制)',
    default: 0,
  },
};

/* 营销常规活动收品列表-收品类型枚举 */
export const GATHERTYPEENUM = {
  0: {
    key: '0',
    des: '默认',
  },
  1: {
    key: '1',
    des: '商品',
  },
  2: {
    key: '2',
    des: '广告',
  },
  3: {
    key: '3',
    des: '促销',
  },
  4: {
    key: '4',
    des: '拼购',
  },
  5: {
    key: '5',
    des: '其它',
  },
  6: {
    key: '6',
    des: '优惠券',
  },
  7: {
    key: '7',
    des: '自建促销',
  },
  9: {
    key: '9',
    des: '自建拼购',
  },
};

/* *******************
 * 以下是该业务模块用到的些比较强业务的工具
 ******************* */
// 计算是否完成
export function computedRatio(data) {
  if (!data) return false;
  if (data && data?.length > 0 && data.indexOf('/') > 0) {
    const ratioArr = data.split('/');
    if (
      ratioArr.length === 2 &&
      ratioArr[0] &&
      ratioArr[1] &&
      !Number.isNaN(ratioArr[0]) &&
      !Number.isNaN(ratioArr[1]) &&
      Number(ratioArr[0]) === Number(ratioArr[1])
    ) {
      if (Number(ratioArr[0]) === 0 && Number(ratioArr[1]) === 0) {
        //`0/0`---过期的
        return [true, 'OVERDATE'];
      } else {
        return [true, ''];
      }
    } else {
      return [false, ''];
    }
  } else {
    return [false, ''];
  }
}

// 相对时间 【格式剩X天X时X分,3天以内显示】
export function dateDurationFormat(originDate, nowDate) {
  const m1 = nowDate ? moment(nowDate) : moment(); //当下时间
  const m2 = moment(originDate);
  const du = moment.duration(m2 - m1, 'ms');
  const years = du.get('years');
  const months = du.get('months');
  const days = du.get('days');
  const hours = du.get('hours');
  const mins = du.get('minutes');
  // const ss = du.get('seconds');

  if (years > 0 || months > 0) {
    return null;
  }

  if (days > 3) {
    return null;
  } else if (days > 0 && days <= 3) {
    return `剩${days}天${hours}时${mins}分`;
  } else if (days === 0) {
    if (hours > 0) {
      return `剩${hours}时${mins}分`;
    } else if (hours === 0) {
      if (mins > 0) {
        return `剩${mins}分`;
      } else {
        return `剩0分`;
      }
    }
  }

  return null;
}
